import { apiService } from "../api.service";

// Requests

// Domain
import { ServiceComment } from "../../models/app/domain";
/**
 * Fetch service comments Request
 * @return - ServiceCommentsResponse || ErrorResponse
 */
export const fetchServiceCommentsRequest = async serviceId => {
  const response = await apiService.get(`/services/${serviceId}/comments`);
  if (response.hasError) {
    return response;
  }
  return {
    comments: response.data.comments.map(
      serviceComment => new ServiceComment(serviceComment)
    )
  };
};

/**
 * Create service comment Request
 * @param serviceCommentFormValues - ServiceCommentFormModel
 * @return - ServiceCommentResponse || ErrorResponse
 */
export const createServiceCommentRequest = async (
  serviceId,
  serviceCommentFormValues
) => {
  const payload = { comment: serviceCommentFormValues.comment };
  const response = await apiService.post(
    `/services/${serviceId}/comments`,
    payload
  );
  if (response.hasError) {
    return response;
  }
  return { comment: new ServiceComment(response.data.comment) };
};

/**
 * Delete comment Request
 * @param id - string
 * @return - SuccessResponse || ErrorResponse
 */
export const deleteCommentRequest = async id => {
  const response = await apiService.delete(`/services/comments/${id}`);
  if (response.hasError) {
    return response;
  }
  return { message: "Comment successfully deleted!" };
};
